module.exports = __webpack_public_path__ + "img/eye.9965ac11.svg";